<template>
  <div class="lang-switcher">
    <vh-dropdown @command="handleLangChange" placement="bottom-end">
      <span style="line-height: 48px; height: 48px">
        <i
          class="vh-saas-iconfont vh-saas-language-outline"
          style="color: #fff; font-size: 20px"
        ></i>
      </span>
      <vh-dropdown-menu slot="dropdown">
        <vh-dropdown-item
          class="lang-dropdown-item"
          v-for="item in langOptions"
          :command="item.key"
          :key="`lang_${item.key}`"
        >
          <span class="lang-text" :class="[$i18n.locale === item.key ? 'active' : '']">
            {{ item.name }}
          </span>
          <!-- <span v-if="">√</span> -->
        </vh-dropdown-item>
      </vh-dropdown-menu>
    </vh-dropdown>
  </div>
</template>

<script>
  import { reloadCurrentPage } from '@/app-shared/utils/common';
  export default {
    name: 'LangSwitcher',
    data() {
      return {
        langOptions: [
          {
            key: 'zh',
            name: '简体中文'
          },
          {
            key: 'en',
            name: 'English'
          }
        ]
      };
    },
    computed: {
      currentLangText() {
        const current = this.langOptions.find(item => item.key === this.$i18n.locale);
        return current.name;
      }
    },
    methods: {
      handleLangChange(lang) {
        if (this.$i18n.locale !== lang) {
          // this.$i18n.locale = lang; // 切换语言
          localStorage.setItem('user-lang', lang); // 持久化存储
          // 刷新
          reloadCurrentPage();
        }
      }
    }
  };
</script>
<style lang="less" scoped>
  .lang-switcher {
    .vh-dropdown span {
      color: #888;
    }
    .vh-dropdown i {
      font-size: 12px;
      color: #979797;
    }
    .vh-icon--right {
      margin-left: 0 !important;
    }
  }
  .lang-dropdown-item {
    min-width: 96px;

    .lang-text {
      position: relative;
      padding-left: 30px;
    }

    .lang-text.active::before {
      content: ''; /* 必须设置，否则伪元素不显示 */
      position: absolute;
      left: 8px;
      top: 50%;
      transform: translateY(-60%) rotate(45deg); /* 关键：旋转形成钩状 */
      width: 6px; /* 对钩短边的宽度 */
      height: 12px; /* 对钩长边的高度 */
      border: solid #fb2626; /* 定义边框样式和颜色 */
      border-width: 0 3px 3px 0; /* 关键：只显示右边框和下边框 */
    }
  }
</style>
